import { render } from "./ReçuHospitalisation.vue?vue&type=template&id=15b32643&scoped=true"
import script from "./ReçuHospitalisation.vue?vue&type=script&lang=js"
export * from "./ReçuHospitalisation.vue?vue&type=script&lang=js"

import "./ReçuHospitalisation.vue?vue&type=style&index=0&id=15b32643&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b32643"]])

export default __exports__